import hljs from 'highlight.js';
import styled from 'styled-components';
import { Text } from 'foundations-components/components/Text';
import { Box } from 'foundations-components/transitional/components/Box';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import 'highlight.js/lib/common';
import { useMemo } from 'react';
import { DuplicateIcon } from 'foundations-assets/icons/components/DuplicateIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HljsCode = styled.code.attrs({
  role: 'code'
}).withConfig({
  displayName: "CodeBlock__HljsCode"
})(["border-radius:0 0 3px 3px;display:inline-block;min-width:100%;box-sizing:border-box;"]);
const CodePre = styled.pre.withConfig({
  displayName: "CodeBlock__CodePre"
})(["overflow-x:auto;"]);
const CodeBlock = ({
  language: manualLanguage,
  code
}) => {
  const highlightResponse = useMemo(() => {
    if (manualLanguage) {
      try {
        return hljs.highlight(code, {
          language: manualLanguage
        });
      } catch (e) {
        return hljs.highlightAuto(code);
      }
    }
    return hljs.highlightAuto(code);
  }, [code, manualLanguage]);
  const derivedLanguage = manualLanguage || highlightResponse.language || 'unknown language';
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(TFlex, {
      backgroundColor: "icon-core-subtle",
      justifyContent: "space-between",
      paddingBlock: "200",
      paddingInline: "400",
      borderStartStartRadius: "100",
      borderStartEndRadius: "100",
      children: [/*#__PURE__*/_jsx(Box, {
        alignSelf: "center",
        children: /*#__PURE__*/_jsx(Text, {
          color: "text-primary-default",
          children: derivedLanguage
        })
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsxs(CopyButton, {
          hint: "Copy to your clipboard.",
          hintSuccess: "Copied!",
          size: "sm",
          use: "unstyled",
          value: code,
          children: [/*#__PURE__*/_jsx(DuplicateIcon, {}), "Copy code"]
        })
      })]
    }), /*#__PURE__*/_jsx(CodePre, {
      children: /*#__PURE__*/_jsx(HljsCode, {
        className: "hljs",
        dangerouslySetInnerHTML: {
          __html: highlightResponse.value
        }
      })
    }), /*#__PURE__*/_jsx("br", {})]
  });
};
export default CodeBlock;